import { PlusIcon } from "@xola/icons";
import { PopoverList } from "@xola/ui-kit";
import clsx from "clsx";
import { DemographicIcon } from "common";
import React, { useState } from "react";
import { CatalogItemObject, ProductCatalogItem, UnitType } from "types";
import { useAutoFetchCollection } from "../../../hooks/useAutoFetchCollection";
import { useVisibility } from "../../../hooks/useVisibility";
import { isDefaultDemographic } from "../../../models/DemographicUnit";
import { NoTranslate } from "../../Common/NoTranslate";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { CreateCatalogItemModal } from "./CreateCatalogItemModal";

interface AddCatalogItemPopoverProps {
    onInsert: (catalogItem: ProductCatalogItem) => void;
}

export const AddCatalogItemPopover = ({ onInsert }: AddCatalogItemPopoverProps) => {
    const [showCreateCatalogItemModal, setShowCreateCatalogItemModal] = useState(false);
    const [visible, { show, hide }] = useVisibility(false);

    const { data: demographicCatalogItems } = useAutoFetchCollection<ProductCatalogItem>("catalogItems", {
        unitType: UnitType.DEMOGRAPHIC,
        object: CatalogItemObject.GLOBAL_CATALOG_ITEM,
    });

    const handleCreateCatalogItem = (catalogItem: ProductCatalogItem) => {
        onInsert(catalogItem);
    };

    const toggleCreateCatalogItemModal = () => {
        setShowCreateCatalogItemModal(!showCreateCatalogItemModal);
    };

    return (
        <>
            <PopoverList visible={visible} className="max-h-96 w-75 overflow-y-scroll" onClickOutside={hide}>
                <SecondaryButton size="small" icon={<PlusIcon />} onClick={visible ? hide : show}>
                    Add Demographic
                </SecondaryButton>

                {demographicCatalogItems?.map((catalogItem: ProductCatalogItem, index: number) => (
                    <PopoverList.Item
                        key={catalogItem.id}
                        className={clsx(index === demographicCatalogItems.length - 1 && "h-13")}
                        onClickItem={() => onInsert(catalogItem)}
                    >
                        <div className="space-x-4">
                            <DemographicIcon name={catalogItem.name} />
                            <NoTranslate if={!isDefaultDemographic(catalogItem.name)}>{catalogItem.name}</NoTranslate>
                        </div>
                    </PopoverList.Item>
                ))}
                <PopoverList.Item name="newAddOn" className="sticky bottom-0 bg-white" onClickItem={() => null}>
                    <SecondaryButton className="w-full" icon={<PlusIcon />} onClick={toggleCreateCatalogItemModal}>
                        Create Demographic
                    </SecondaryButton>
                </PopoverList.Item>
            </PopoverList>
            <CreateCatalogItemModal
                isOpen={showCreateCatalogItemModal}
                onCreate={handleCreateCatalogItem}
                onClose={toggleCreateCatalogItemModal}
            />
        </>
    );
};
